import type { CustomRoleUserUpdateMutation } from '@risksmart-app/web-graphql-client/generated/graphql';
import {
  CustomRoleUserUpdateDocument,
  namedOperations,
} from '@risksmart-app/web-graphql-client/generated/graphql';

import { createMutationHook } from '@/utils/hook-factories';

type UpdateCustomRolesInput = {
  userId: string;
  customRoleIds: string[];
};

export const useUpdateCustomRoles = createMutationHook({
  name: 'updateCustomRoles',
  mutationOptions: (trpc, onSuccess) =>
    trpc.frontend.user.updateCustomRoles.mutationOptions({ onSuccess }),
  mapInput: (input: UpdateCustomRolesInput) => input,
  // Invalidate users list and per-user read paths so the modal and settings
  // table reflect the updated custom-role membership.
  invalidate: (trpc) => [
    trpc.frontend.user.users.queryKey(),
    trpc.frontend.user.userById.queryKey(),
    trpc.frontend.user.userByIdWithRoles.queryKey(),
    // COI-889: role and module grants feed `getTypePermissions` and
    // `checkNavigationVisibility`, both cached for 60 min with
    // `refetchOnMount: false`.
    trpc.frontend.permission.pathKey(),
  ],
  mapResponse: (result: {
    affected_rows: number;
  }): CustomRoleUserUpdateMutation => ({
    customRoleUserUpdate: {
      affected_rows: result.affected_rows,
    },
  }),
  graphqlDocument: CustomRoleUserUpdateDocument,
  graphqlVariables: (input: UpdateCustomRolesInput) => ({
    input: {
      UserId: input.userId,
      CustomRoleIds: input.customRoleIds,
    },
  }),
  evictFields: ['custom_role_user', 'auth_user', 'auth_user_by_pk'],
  refetchQueries: [namedOperations.Query.GetAuthUserByIdWithRoles],
});
